var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseGateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6H8V3C8 1.34375 6.65625 0 5 0C3.34375 0 2 1.34375 2 3V6H1C0.45 6 0 6.45 0 7V13C0 13.55 0.45 14 1 14H9C9.55 14 10 13.55 10 13V7C10 6.45 9.55 6 9 6ZM3 3C3 1.89688 3.89687 1 5 1C6.10313 1 7 1.89688 7 3V6H3V3ZM4 10C4 10.5531 4.44688 11 5 11C5.55312 11 6 10.5531 6 10C6 9.44687 5.55312 9 5 9C4.44688 9 4 9.44687 4 10Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGateIcon);
export default __webpack_public_path__ + "static/media/CloseGateIcon.57013006074486e78196ec71c586b269.svg";
export { ForwardRef as ReactComponent };